import { Button, DateInput, FormElement, TextAreaInput, TimeInput } from 'b3';
import React from 'react';
import { connect } from 'react-redux';
import { openModal } from '../../actions/ModalActions';
import ContactCardDropdown from '../../components/contact-card/ContactCardDropdown';
import StaffMemberPicker from '../../components/StaffMemberPicker';
import { completeWithNoFollowUpCall, completeWizard, goBack, goToStep, updateCallData } from './logActivityReducer';

@connect(
    state => ({
        contacts: state.activeClient.contacts,
        client: state.activeClient.client,
        callData: state.logActivityWizard.callData,
        employees: state.users.users,
    }),
    { openModal, goToStep, updateCallData, completeWizard, completeWithNoFollowUpCall, goBack }
)
export default class EditCallStep extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            description: props.callData.description
        };
    }
    componentDidMount() {
        if(this.notesInput) {
            this.notesInput.focus();
        }
    }
    updateTime(newTime) {
        console.log('new', newTime);
        var date = this.props.callData.date
            .hours(newTime.hours())
            .minutes(newTime.minutes());

        this.props.updateCallData({date});
    }
    updateDate(newDate) {
        var date = this.props.callData.date
            .date(newDate.date())
            .year(newDate.year())
            .month(newDate.month());

        this.props.updateCallData({date});
    }
    handleContactChange(participatingContactId) {
        this.props.updateCallData({participatingContactId});
    }
    canSubmit() {
        // check has date, assignedTo and Contact
    	return true;
    }
    updateDescription(description) {
        this.setState({description});
    }
    handleEmployeeSelected(employee) {
        this.props.updateCallData({assignedEmployees: [employee]});
    }
    handleEmployeeDeselected(employee) {
        this.props.updateCallData({assignedEmployees: []});
    }
    handleNoFollowUp() {
        this.props.completeWithNoFollowUpCall();
    }
    onUserSelected(assignedEmployeeIds) {
        this.props.updateCallData({assignedEmployeeIds});
    }
    updateCall = () => {
        var { description } = this.state;
        this.props.updateCallData({description});
        this.props.completeWizard();
    }
    handleNoteTextChange = (notes) => {
        this.props.updateCallData({notes});
    }
    render() {
        var { client, callData, contacts } = this.props;
        var { date, description, participatingContactId, assignedEmployeeIds, createdAt, notes } = callData;

        // if done show notes

        console.log('CD', callData);

        return (
        	<div className="wizard-step-wrapper">
                <h1>Change Phone Call</h1>
                {createdAt &&
                    <div className="form-row">
                        <h2>
                            Call notes
                        </h2>
                        <div>
                            <TextAreaInput
                                ref={el => this.notesInput = el}
                                rows={3}
                                placeholder="Enter the call notes"
                                value={notes} 
                                onChange={this.handleNoteTextChange} />
                        </div>
                    </div>
                }
                <div style={{display: "flex"}}>
                    <h2 style={{marginRight: 15}}>Time</h2>
                    <div style={{flex: 1}}>
                        <FormElement icon="clock-2">
                            <TimeInput
                                value={date}
                                onChange={this.updateTime.bind(this)}
                            />
                        </FormElement>
                    </div>
                    <div style={{flex: 1}}>
                        <FormElement icon="calendar-2" style={{width: "170px"}}>
                            <DateInput
                                submitOnChangeOnly={true}
                                value={date}
                                onChange={this.updateDate.bind(this)}
                            />
                        </FormElement>
                    </div>
                </div>
                <div>
                    <h2>Call Contact</h2>
                    <ContactCardDropdown
                        selectedContactId={participatingContactId}
                        onChange={this.handleContactChange.bind(this)}
                        contacts={contacts}
                        clientId={client.id} />
                </div>
                <div style={{display: 'flex', alignItems: 'center', marginTop: 15}}>
                    <h2 style={{margin: 0}}>
                        Assigned To
                    </h2>
                    <div style={{flex: 1, marginLeft: 15}}>
                        <StaffMemberPicker 
                            onSelectChange={this.onUserSelected.bind(this)}
                            includeAvatarPicker={false}
                            onlyOneAssign={true} 
                            assignedUserIds={assignedEmployeeIds} 
                            callersOnly={true} />
                    </div>
                </div>
                <div style={{display: 'flex', alignItems: 'center', marginTop: 15}}>
                    <h2>
                        Agenda
                    </h2>
                    <div style={{flex: 1, marginLeft: 35}}>
                        <TextAreaInput 
                            rows={4}
                            placeholder="Enter the agenda for the next call"
                            initialValue={description} 
                            onChange={this.updateDescription.bind(this)} />
                    </div>
                </div>

                <div className="save-and-back-or-complete-wrapper">
                    <Button type="primary" onClick={this.updateCall}>Update Call</Button>    
                </div>

                
        	</div>
        );
    }
}


// WEBPACK FOOTER //
// ./app/components/schedule-wizard/EditCallStep.js